import { IPersonalizationData } from '../../../api/PersonalizationApiSdk';

export class Personalization {
    public id: string;
    public userPersonalizationData: string;
    public tags: string[];
    public userId: string;
    public userType: string;
    public creationDate: string;

    public static fromJson(data: IPersonalizationData): Personalization {
        const personalization = new Personalization();
        personalization.id = data.id;
        personalization.userPersonalizationData = data.userPersonalizationData;
        personalization.tags = data.tags;
        personalization.userId = data.userIdentifier;
        personalization.userType = data.userIdentifierType;
        personalization.creationDate = data.creationDate;

        return personalization;
    }
}
